import React, { useState, useEffect, useRef } from "react";
import { Box, DataGrid, SelectBox } from "devextreme-react";
import { Item } from "devextreme-react/box";
import http from "../../utils/http";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import { Column, Editing, Popup, Form, Button, Pager, Paging, GroupPanel, SearchPanel, Grouping, RemoteOperations, Lookup } from "devextreme-react/data-grid";
import ItemProperties from "../../components/itemProperties/ItemProperties";
import { useDispatch } from 'react-redux';
import { Label } from "devextreme-react/form";
import { CommonSeriesSettingsHoverStyle } from "devextreme-react/chart";
import Title from "../../components/shared/Title";
import BlockHeader from "../../components/shared/BlockHeader";
import { openThisDialog } from '../../store/dialog/dialogReducer';
import { openEditDialog } from "../../store/editDialog/editDialogReducer";
import AddCatalogEntryDialog from "./AddCatalogEntryDialog";
import EditCatalogEntryDialog from "./EditCatalogEntryDialog";
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";


const descriptionEditorOptions = { height: 100 };

const defualtItem = {
    name: null,
    entries: [],
    catalogs: []
};

const DetailTemplate = props => {

    let dispatch = useDispatch();
    const gridRef = useRef();

    const [item, setItem] = useState(defualtItem);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = () => {
        Promise.all([
            http(uri.catalogEntries(props.data.key)).asGet(),
            http(uri.catalogEntriesSearch).asGet()
        ]).then(result => {
            setItem({
                ...item,
                name: props.data.key,
                entries: [...result[0]],
                catalogs: result[1]
            });
        });
    };

    const onToolbarPreparing = e => {

        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon: 'xlsxfile',
                type: 'success',
                stylingMode: "outlined",
                onClick: () => gridRef.current.instance.exportToExcel(false)
            }
        });
    }

    const refreshGrid = () => {
        gridRef.current.instance.refresh();
    }



    const getFilteredParentCatalog = () => {

        switch (item.name) {

            case 'ModeloLenteOftalmico':
                return item.catalogs.filter(x => x.catalog ==='MarcaLenteOftalmico');

            case 'ModeloLenteContacto':
                return item.catalogs.filter(x => x.catalog === 'MarcaLenteContacto');

            case 'ModeloMarcoAro':
                return item.catalogs.filter(x => x.catalog === 'MarcaMarcoAro');

            case 'ModeloLentesEsclerales':
                return item.catalogs.filter(x => x.catalog === "MarcaLentesEsclerales" || x.catalog === "DiseñoLenteEsclerales"); 
            case 'TipoLentesEsclerales':
                    return item.catalogs.filter(x => x.catalog === "DiseñoLenteEsclerales");    
            default:
                return item.catalogs;
        }

    }

    return (
        <>
            <DataGrid
                dataSource={item.name == null ? null : store({ uri: { get: uri.catalogEntries(item.name), insert: uri.catalogEntries(item.name) } })}
                showBorders={true}
                selection={{ mode: 'single' }}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
                rowAlternationEnabled={true}
                remoteOperations={{
                    paging: true,
                    filtering: true

                }}
                ref={gridRef}
            >
                <Editing
                    // mode="popup"
                    allowUpdating={true}
                    allowDeleting={false}
                    allowAdding={true}
                    useIcons={true}
                >

                </Editing>



                <Pager allowedPageSizes={[15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                <Paging defaultPageSize={15} />
                <Column dataField="id" caption="Id" width={60} visible={false} allowEditing={false} allowGrouping={false} />
                <Column dataField="value" caption="Valor" allowGrouping={false} />
                <Column dataField="parentId" caption="Dependencia Padre"  >
                    <Lookup dataSource={getFilteredParentCatalog}
                        grouped={true}
                        showClearButton={true}
                        valueExpr="id"
                        displayExpr="value" />
                </Column>

            </DataGrid>
        </>
    );
}

export default DetailTemplate;